// Tokens de tema copiados de docs/design/UI mockups planning/Tema e Cores.dc.html.
// Os nomes são iguais nos dois temas; só o valor muda.
export const lightTheme = {
  bgApp: '#f5f3ef',
  bgSidebar: '#efece6',
  surface: '#fdfcfa',
  surface2: '#f3f0eb',
  border: '#e3ded6',
  borderStrong: '#d4cec4',
  ink: '#1f1d1a',
  ink2: '#5b564e',
  muted: '#6b665e',
  faint: '#9a948a',
  accent: '#2f6b5f',
  accentHover: '#25574d',
  accentSoft: '#e3eeea',
  onAccent: '#ffffff',
  warn: '#8f6212',
  warnSoft: '#f6eddb',
  danger: '#a8452f',
  dangerSoft: '#f6e5df',
  pro1: '#c0736a',
  pro1Soft: '#f6e9e6',
  pro2: '#6b87bf',
  pro2Soft: '#e8edf6',
  pro3: '#b0924a',
  pro3Soft: '#f3eedf',
  pro4: '#9a7bb8',
  pro4Soft: '#efe9f5',
  pro5: '#6f9a6a',
  pro5Soft: '#e8f0e6',
  invert: '#1f1d1a',
  onInvert: '#f5f3ef',
};

export type ThemeTokens = { [K in keyof typeof lightTheme]: string };

export const darkTheme: ThemeTokens = {
  bgApp: '#171614',
  bgSidebar: '#1c1b18',
  surface: '#22201d',
  surface2: '#2b2926',
  border: '#34312c',
  borderStrong: '#46423b',
  ink: '#ece8e1',
  ink2: '#c4bfb6',
  muted: '#a39d93',
  faint: '#7f796f',
  accent: '#6fb3a3',
  accentHover: '#86c4b5',
  accentSoft: '#1f3530',
  onAccent: '#0f1f1b',
  warn: '#d9a54a',
  warnSoft: '#372c19',
  danger: '#e08a72',
  dangerSoft: '#3a2520',
  pro1: '#d99489',
  pro1Soft: '#3a2826',
  pro2: '#8fa6d6',
  pro2Soft: '#252c3b',
  pro3: '#cdb06a',
  pro3Soft: '#332c1c',
  pro4: '#b69ad1',
  pro4Soft: '#2f2738',
  pro5: '#8fb98a',
  pro5Soft: '#243021',
  invert: '#ece8e1',
  onInvert: '#171614',
};

export const breakpoints = { sm: 640, md: 768, lg: 1024, xl: 1280 } as const;

/** Cores por profissional: mesma luminosidade, matiz variando. Índice cíclico. */
export function memberColor(index: number): { strong: string; soft: string } {
  const i = ((index % 5) + 5) % 5;
  const keys = ['pro1', 'pro2', 'pro3', 'pro4', 'pro5'] as const;
  const k = keys[i]!;
  return { strong: `var(--color-${k})`, soft: `var(--color-${k}-soft)` };
}
